<script setup lang="ts">
import {CAPTURE_FLAG_DIALOG_DISPLAY_REQUESTED} from "~/types/bus-event-names"
import Dialog from "~/components/molecules/Dialog.vue"

const dialog = ref<typeof Dialog | null>(null)
const reason = ref('')
const pending = ref(false)
const error = ref(false)
const success = ref(false)

const props = defineProps<{
  captureCode: string
}>()

const disabled = computed(() => {
  return reason.value.length < 16 || pending.value
})

useBusEvent(CAPTURE_FLAG_DIALOG_DISPLAY_REQUESTED, show)

function show() {
  dialog.value?.show()
}

async function onSubmit() {

  if (pending.value) {
    return
  }

  pending.value = true
  error.value = false

  const {error: flagError} = await postCaptureFlag(props.captureCode, reason.value)

  if (flagError.value) {
    pending.value = false
    error.value = true

    return
  }

  success.value = true

  setTimeout(() => {
    pending.value = false
    success.value = false
    reason.value = ''
    dialog.value?.close()
  }, 2000)
}
</script>

<template>
  <MoleculesDialog ref="dialog">
    <form class="bg-white rounded-bento p-4" @submit.prevent="onSubmit">
      <AtomsHeadingsLarge class="mb-5">{{ $t('capture.flag.title') }}</AtomsHeadingsLarge>
      <AtomsFormTextArea class="mb-3" :label="$t('capture.flag.label')" :required="true" v-model="reason"
                         input-class="h-24"/>
      <div class="text-right">
        <AtomsButton :label="success ? $t('_global.thanks') : $t('_global.send')" dark-color="domain" tag="button"
                     :disabled="disabled"/>
        <p v-if="error" class="mt-2">{{ $t('_global.error') }}</p>
      </div>
    </form>
  </MoleculesDialog>
</template>